import { render, staticRenderFns } from "./VR.md?vue&type=template&id=5fa00973&"
import script from "./VR.md?vue&type=script&lang=js&"
export * from "./VR.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports